import { useNavigate } from "react-router-dom"
import { IRedirectParams } from "../../interfaces"

export const useRedirect = (params?: IRedirectParams) => {
	const navigate = useNavigate()

	if (!params) {
		return
	}

	setTimeout(() => navigate(params.to), (params.delay ?? 0) * 1000)
}
